<template>
  <CSidebar
    aside
    :show="$store.state.asideShow"
    color-scheme="light"
    overlaid
    size="lg"
    @update:show="val => $store.commit('set', ['asideShow', val])"
  >
    <CSidebarClose @click.native="$store.commit('toggle', 'asideShow')" />
  </CSidebar>
</template>

<script>
export default {
  name: 'TheAside'
}
</script>
